import React, { FC } from 'react';
import { Row, Typography } from 'components';
import { Badge } from 'antd';
import styles from './styles.module.scss';

const { Text } = Typography;

export type SupplierStatusType = 'MAIN_SUPPLIER' | 'PRICE_REFERENCE' | 'RECOMMENDED' | 'BLACKLISTED' | 'INACTIVE';

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};

export const DEFAULT_STATUS: StatusMapType = {
  label: 'Unknown',
  color: '#f0f0f0',
  dotColor: 'gray',
};

export const SUPPLIER_STATUS_MAPPING: Record<SupplierStatusType, StatusMapType> = {
  RECOMMENDED: {
    label: 'Recommended',
    color: '#E6F0FF',
    dotColor: 'blue',
  },
  MAIN_SUPPLIER: {
    label: 'Main Supplier',
    color: '#E0FAEC',
    dotColor: 'green',
  },
  PRICE_REFERENCE: {
    label: 'Price Reference',
    color: '#EEEFFF',
    dotColor: '#5865F2',
  },
  INACTIVE: {
    label: 'Inactive',
    color: '#E1E4EA',
    dotColor: '#525866',
  },
  BLACKLISTED: {
    label: 'Blacklisted',
    color: '#fff2f0',
    dotColor: 'red',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: string; // now accepting unknown status types too
}

export const SupplierStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = SUPPLIER_STATUS_MAPPING[type as SupplierStatusType] ?? DEFAULT_STATUS;

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 10, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
